import React, { useEffect } from 'react';
import { generateClient } from 'aws-amplify/api';
import { getCurrentUser} from 'aws-amplify/auth';
import { createDevelopmentPlan, deleteDevelopmentPlan } from '../../graphql/mutations';
import { getUser } from '../../graphql/queries';
import { v4 as uuidv4 } from 'uuid';

import { useMapContext } from '../Map/MapContext';
import DevelopmentPlanSelector from './DevelopmentPlanSelector'
import LIDSummary from './LIDSummary';
import AddLIDPanel from './AddLIDPanel';
import RunModel from './RunModel';

const client = generateClient();

const LIDPanel = ({userData: initialUserData}) => {

    const {
        userData, 
        setUserData,
        devPlanID,
        setDevPlanID,
        LIDMode,
        selectedFeature,
        mapClickInfo,
        selectedStormOption,
        setInpFile,
        devPlanContent,
        aggregatedCounts,
        setAggregatedCounts,
        aggregateLIDCounts,
        planHasBeenRun
    } = useMapContext();

    const selectedFeatureData = selectedFeature.Data;
    const selectedLayer = mapClickInfo.selectedLayer;

    useEffect(() => {
        if (devPlanContent) {
            setAggregatedCounts(aggregateLIDCounts(devPlanContent));
        } 
        console.log("The aggregatedCounts are: ", aggregatedCounts);
    }, [devPlanContent, devPlanID, selectedStormOption]);

    useEffect(() => {   
        let selectedPlan = userData?.developmentPlans?.items.find(plan => plan.id === devPlanID);
        if (selectedPlan) {
            console.log("The devPlanID is now: ", selectedPlan.name);
        } 
    }, [devPlanID, userData]);

    useEffect(() => {
        if (selectedStormOption && userData && userData.id && devPlanID) {
            let selectedPlan = userData?.developmentPlans?.items.find(plan => plan.id === devPlanID);
            if (selectedPlan) {
                setInpFile(`GLWA_${selectedStormOption}_${userData.id}_${devPlanID}.inp`);
                console.log("The inpFile is now: ", `GLWA_${selectedStormOption}_${userData.id}_${devPlanID}.inp`);
            }
        }
    }, [selectedStormOption, userData, devPlanID]);

    useEffect(() => {
        if (LIDMode) {
            console.log("We turned LIDMode on");
            if (userData && userData.id) {
                if (userData.developmentPlans && userData.developmentPlans.items) {
                    console.log("This is what we found in userData.developmentPlans: ", userData.developmentPlans.items);
                    if (userData.developmentPlans.items.length > 0) {
                        console.log("The devPlanID is: ", devPlanID);
                        if (devPlanID === 10) {
                            setDevPlanID(userData.developmentPlans.items[0].id);
                        }
                    }
                } else {
                    console.log("We don't have any development plans yet");
                }
                // checkAndCreateDevelopmentPlan();
            } else {
                console.log("we don't have userData yet, so we're fetching it");
                fetchUserData();
            }
        }
    }, [LIDMode, userData]);

    const fetchUserData = async () => {
        try {
            const { username: userId } = await getCurrentUser();
            const userDataResponse = await client.graphql({
                query: getUser,
                variables: { id: userId }
            });
            setUserData(userDataResponse.data.getUser);
            console.log("Reran fetchUserData: ", userDataResponse.data.getUser);
        } catch (error) {
            console.error('Error fetching user data:', error);
        }
    };

    // const checkAndCreateDevelopmentPlan = async () => {
    //     // let's re-get the userData if there are no development plans
    //     if (!userData.developmentPlans.items) {
    //         try {
    //             const { username: userId } = await getCurrentUser();
    //             const userDataResponse = await client.graphql({
    //                 query: getUser,
    //                 variables: { id: userId }
    //             });
    //             let newUserData = userDataResponse.data.getUser
    //             setUserData(newUserData);
    //             console.log("Reran fetchUserData: ", newUserData);

    //             const devPlans = newUserData.developmentPlans?.items;
    //             if (devPlans && devPlans.length > 0) {
    //                 console.log('LID Panel sees userData:', devPlans);
    //             } else {
    //                 console.log('No development plans found');
    //                 createDefaultDevelopmentPlan();
    //             }
    //         } catch (error) {
    //             console.error('Error fetching user data:', error);
    //         }
    //     } else {
    //         const devPlans = userData.developmentPlans?.items;
    //         if (devPlans && devPlans.length > 0) {
    //             console.log('LID Panel sees userData:', devPlans);
    //         } else { // I don't think this else statement should ever run -- 
    //             console.log('No development plans found');
    //             console.log("This else statement shouldn't have run - go find it in the code!")
    //             createDefaultDevelopmentPlan();
    //         }
    //     }
    // };

    // const createDefaultDevelopmentPlan = async () => {
    //     console.log("The userData is: ", userData);
    //     if (!userData || !userData.id) {
    //         console.error('Cannot create development plan: User ID is missing');
    //         return;
    //     }

    //     if (userData.developmentPlans && userData.developmentPlans.items.length > 0) {
    //         console.error('Cannot create template development plan: There are already development plans');
    //         return;
    //     }

    //     try {
    //         const newPlan = {
    //             id: uuidv4(),
    //             name: "myFirstDevPlan",
    //             version: 1,
    //             userID: userData.id
    //         };
    //         const result = await client.graphql({
    //             query: createDevelopmentPlan,
    //             variables: { input: newPlan }
    //         });
    //         console.log('Created new development plan:', result.data.createDevelopmentPlan);
    //         setDevPlanID(result.data.createDevelopmentPlan.id);
    //     } catch (error) {
    //         console.error('Error creating development plan:', error);
    //     }
    // };

    if (!LIDMode) return null;
    return (
        <div>
            <DevelopmentPlanSelector />

            {planHasBeenRun && devPlanContent && Object.keys(devPlanContent).length > 0 && (
                <LIDSummary />
            )}

            {selectedFeatureData && !planHasBeenRun && (selectedLayer === 'subcatchment') && (
                <AddLIDPanel />
            )}

            <RunModel />

        </div>
    );
};

export default LIDPanel;

